"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSharedInfo = void 0;
const utils_1 = require("./utils");
class SetSharedInfo {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    static getInstance() {
        return new SetSharedInfo();
    }
    setDomElement(domElement) {
        utils_1.originReference.domElement = domElement;
    }
    setStore(store) {
        utils_1.originReference.store = store;
    }
    setHistory(history) {
        utils_1.originReference.history = history;
    }
    setInitializedFeatures(initializedFeatures) {
        utils_1.originReference.initializedFeatures = initializedFeatures;
    }
    setExternalComponents(externalComponents) {
        utils_1.originReference.externalComponents = externalComponents;
    }
    setData(data) {
        utils_1.originReference.data = data;
    }
}
exports.SetSharedInfo = SetSharedInfo;
//# sourceMappingURL=setSharedInfo.js.map